import { type Dispatch, type SetStateAction, useCallback, useRef, useState } from 'react';

import { isRovoJourneyIdEnabled } from '../../common/utils/quick-find/rovo-journey-id';
import { usePrimaryProduct } from '../../controllers/store/bootstrap';
import { useQuickFindActions } from '../../controllers/store/quick-find';

export const useLocalQueryWithRovoJourneyId = (
	initialQuery: string | (() => string),
): [string, Dispatch<SetStateAction<string>>] => {
	const [localQuery, setLocalQueryState] = useState<string>(initialQuery);
	const localQueryRef = useRef(localQuery);
	localQueryRef.current = localQuery;
	const [primaryProduct] = usePrimaryProduct();
	const { refreshRovoJourneyId } = useQuickFindActions();
	const journeyContextRef = useRef({ primaryProduct, refreshRovoJourneyId });
	journeyContextRef.current = { primaryProduct, refreshRovoJourneyId };

	const setLocalQuery = useCallback<Dispatch<SetStateAction<string>>>((value) => {
		if (!isRovoJourneyIdEnabled(journeyContextRef.current.primaryProduct)) {
			setLocalQueryState(value);
			return;
		}

		const previousQuery = localQueryRef.current;
		const nextQuery = typeof value === 'function' ? value(previousQuery) : value;

		localQueryRef.current = nextQuery;
		if (previousQuery.trim().length > 0 && nextQuery.trim().length === 0) {
			journeyContextRef.current.refreshRovoJourneyId();
		}

		setLocalQueryState(nextQuery);
	}, []);

	return [localQuery, setLocalQuery];
};
